import { Banner, BannerClickAction } from '@medprev-web-app/api-graphql-client';

export function resolveBannerClickAction({
  actionTypeOnBannerClick,
  actionOnBannerClick,
  modalTitle,
}: Banner): BannerClickAction | null {
  if (actionTypeOnBannerClick === BannerClickAction.Search) {
    return BannerClickAction.Search;
  }

  if (actionTypeOnBannerClick === BannerClickAction.Modal && modalTitle) {
    return BannerClickAction.Modal;
  }

  if (actionOnBannerClick) {
    return BannerClickAction.Url;
  }

  if (modalTitle) {
    return BannerClickAction.Modal;
  }

  return null;
}
